export const claimTypes = {
    "READ_WRITE": 'readWrite',
    "READ": 'read',
    "NONE": 'none'
};
